'use client'
import { createContext, useContext } from "react";
const CarouselAutoplayContext = /*#__PURE__*/ createContext(null);
function useCarouselAutoplayContext() {
    const context = useContext(CarouselAutoplayContext);
    if (!context) throw new Error('useCarouselAutoplayContext must be used within a CarouselAutoplayProvider');
    return context;
}
function useOptionalCarouselAutoplayContext() {
    return useContext(CarouselAutoplayContext);
}
export { CarouselAutoplayContext, useCarouselAutoplayContext, useOptionalCarouselAutoplayContext };
